import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/lib/motion";
import { BookingProvider } from "@/components/bwg/BookingModal";
import ScrollToTop from "@/components/bwg/ScrollToTop";
import Home from "@/pages/Home";
import OurApproach from "@/pages/OurApproach";
import AboutUs from "@/pages/AboutUs";
import Careers from "@/pages/Careers";
import Ayodhya from "@/pages/Ayodhya";
import Press from "@/pages/Press";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <>
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.25, ease: "easeInOut" }}
        >
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/our-approach" element={<OurApproach />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/ayodhya" element={<Ayodhya />} />
            <Route path="/press" element={<Press />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <SmoothScroll>
        <BrowserRouter>
          <BookingProvider>
            <AnimatedRoutes />
          </BookingProvider>
        </BrowserRouter>
      </SmoothScroll>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
